// import IconFont from '../IconFont';
import '@umijs/max';
import { ReactComponent as IconChatbot } from '@/assets/icon-chatbot.svg';

export type SiderTheme = 'light' | 'dark';

export const ChatbotAction: React.FC<{ onClick: () => void }> = ({
  onClick,
}) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
        marginRight: '10px',
      }}
      onClick={onClick}
    >
      {/* <IconFont type="icon-robot" /> */}
      <IconChatbot style={{ width: '28px', height: '28px' }} />
    </div>
  );
};
